const DATA_APP_AUTO_ANALYSIS = new Set([
    'inherit',
    'on',
    'off',
]);
export const isDataAppAutoAnalysis = (value) => typeof value === 'string' && DATA_APP_AUTO_ANALYSIS.has(value);
/** A stored value outside the set reads back as the org default. */
export const normalizeDataAppAutoAnalysis = (value) => (isDataAppAutoAnalysis(value) ? value : 'inherit');
export const DATA_APP_ANALYSIS_DEFAULT_LIMITS = {
    investigateMaxSteps: 12,
    investigateMaxWarehouseQueries: 15,
    dailyDetectCap: 300,
    dailyInvestigateCap: 100,
    dailyPromptCap: 500,
};
//# sourceMappingURL=analysis.js.map